import { render } from "./CurriculumTab.vue?vue&type=template&id=6381214f"
import script from "./CurriculumTab.vue?vue&type=script&lang=js"
export * from "./CurriculumTab.vue?vue&type=script&lang=js"

import "./CurriculumTab.vue?vue&type=style&index=0&id=6381214f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__